import { useUser } from "@clerk/clerk-react";
import { useSuspenseQuery } from "@tanstack/react-query";
import { createFileRoute, Outlet } from "@tanstack/react-router";
import { fetchAccessProfileQueryOptions } from "@/api/accessProfile";
import { ErrorPage } from "@/components/ErrorPage";
import { useApiParameters } from "@/hooks/useApiParameters";
import { AppBaseLayout } from "@/routes/_auth/app/_app/-components/AppBaseLayout";

export const Route = createFileRoute("/_auth/app/_app")({
	beforeLoad: ({ context }) => {
		if (!context.get_token()) {
			throw new Error("Not authenticated");
		}
	},
	loader: async ({ context }) => {
		const { userId, token } = useApiParameters(
			context.userId,
			await context.get_token(),
		);

		context.queryClient.ensureQueryData(
			fetchAccessProfileQueryOptions(userId, token),
		);

		return { userId, token };
	},
	component: RouteComponent,
	errorComponent: ErrorPage,
});

function RouteComponent() {
	const { userId, token } = Route.useLoaderData();
	const { user } = useUser();
	const { data: accessProfile } = useSuspenseQuery(
		fetchAccessProfileQueryOptions(userId, token),
	);

	const userName = user?.fullName || user?.firstName || accessProfile.email;

	return (
		<AppBaseLayout userName={userName} userRole={accessProfile.role}>
			<Outlet />
		</AppBaseLayout>
	);
}
